import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/skl-logo.png'


const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "nav-container" }

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import AppNavigation from '@/components/widgets/AppNavigation.vue'
import LocaleSwitcher from '@/components/widgets/LocaleSwitcher.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute()

const isExpanded = ref<boolean>(false)
const isLoginPossible = ref<boolean>(false)
const isNavAvailable = ref<boolean>(false)

const homepageUrl: string =
  process.env.VUE_APP_HOMEPAGE_URL ?? 'https://keilailu.fi/'

const setNavExpanded = (value: boolean): void => {
  isExpanded.value = value
  document.scrollingElement?.scrollTo({ top: 0, behavior: 'smooth' })
  value
    ? document.body.classList.add('no-scroll')
    : document.body.classList.remove('no-scroll')
}

watch(
  () => route.path,
  () => {
    isLoginPossible.value = route.meta.isLoginPossible as boolean
    isNavAvailable.value = route.meta.isNavAvailable as boolean
    setNavExpanded(false)
  },
)

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ 'is-expanded': isExpanded.value })
  }, [
    _createElementVNode("div", {
      class: "nav-toggle-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setNavExpanded(!isExpanded.value)))
    }, [
      _createVNode(_component_FontAwesomeIcon, {
        class: "nav-toggle-button-icon",
        icon: isExpanded.value ? 'xmark' : 'bars'
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _unref(homepageUrl),
        target: "_blank"
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo"
        }, null, -1)
      ]))], 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppNavigation, {
        "is-authenticated": isNavAvailable.value,
        "is-login-possible": isLoginPossible.value
      }, null, 8, ["is-authenticated", "is-login-possible"]),
      _createVNode(LocaleSwitcher)
    ])
  ], 2))
}
}

})